import React, {useEffect, useMemo, useState} from "react";
import {useNavigate} from "react-router";
import {useTranslation} from "react-i18next";
import useInputValue from "../../hooks/useInputValue";
import useValidation from "../../hooks/useValidation";
import {showToast} from "../../components/general/CustomToast";
import {Card, Typography} from "@material-tailwind/react";
import Logo from "../../components/general/Logo";
import CustomInput from "../../components/general/CustomInput";
import CustomInputPassword from "../../components/general/CustomInputPassword";
import CustomButton from "../../components/general/CustomButton";
import getConstrains from "../../utils/validationConstraints";
import {useCredentials} from "../../services/session/apiSession";
import {useSessionStore} from "../../services/storage/SessionStorage";

interface ErrorProps {
    username?: string;
    password?: string;
}

export default function Login() {
    const history = useNavigate();
    const {t} = useTranslation("global") as { t: (key: string) => string }
    const {mutate, isPending, data: successLogin} = useCredentials()
    const setData = useSessionStore(state => state.setData)

    const username = useInputValue('')
    const password = useInputValue('')

    const [errors, setErrors] = useState<ErrorProps | null>();
    const validationSchema = useMemo(() => getConstrains(['username', 'password']), []);
    const validation = useValidation(validationSchema);

    const login = () => {
        const data = {
            username: username.value,
            password: password.value
        }
        const errorsValidation = validation(data);
        if (errorsValidation) {
            setErrors(errorsValidation);
            showToast(t('field-validation'), 'error');
        } else {
            setErrors(null)
            mutate(data)
        }
    }

    useEffect(() => {
        if (successLogin) {
            setData(successLogin)
            history('/')
        }
    }, [successLogin]);

    return (
        <div className={"h-screen relative grid justify-center items-center"}>
            <Card placeholder={'card-login'} className={"p-4 pb-8 sm:w-[415px]"} shadow={false}>
                <div className={"grid justify-end"}>
                    <Logo width={75}/>
                </div>
                <Typography placeholder={'login-title'} variant="h4" color="blue-gray">
                    {t('welcome')}
                </Typography>
                <Typography placeholder={'alet-title'} color="gray" className="mt-1 font-normal">
                    {t('login')}
                </Typography>
                <div className="my-5 flex flex-col gap-2">
                    <CustomInput
                        classNameContent={'mb-4'}
                        className={'min-h-[54px] max-h-[54px] h-[54px]'}
                        classNameError={'mt-[15px]'}
                        labelFixel={true}
                        label={'Username'}
                        error={errors?.username}
                        {...username}
                    />
                    <CustomInputPassword error={errors?.password} eventSistem={() => {
                        login()
                    }} {...password}/>
                </div>
                <CustomButton
                    variant="gradient"
                    disabled={isPending}
                    onClick={login}
                    loading={isPending}
                    text={t('loginText')}
                />
            </Card>
        </div>
    )
}
